import { DriveUserActionType } from '../../../drive/userActions';

export const driveUserActions = [
  DriveUserActionType.LIST_OBJECTS,
  DriveUserActionType.READ_OBJECTS,
  DriveUserActionType.WRITE_OBJECTS,
  DriveUserActionType.DELETE_OBJECTS,
];

export const getDrivePermissions = (permissions: boolean[]) => {
  const [canListObjects = false, canReadObjects = false, canWriteObjects = false, canDeleteObjects = false] =
    permissions;

  const isReader = canListObjects;
  const isWriter = isReader && canWriteObjects && canDeleteObjects;

  return { isReader, isWriter, canDownload: canReadObjects };
};
